export default "__VITE_ASSET__X58pHNka__"